module.exports = __webpack_public_path__ + "img/female.adb7ee60.svg";